// extracted by mini-css-extract-plugin
module.exports = {"noLabel":"KDropdown_noLabel__1jhEm"};